import Badge from '@components/Badge';
import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import PinFixedFill from '@icons/PinFixedFill';
import { EventRow } from '@models/event';
import { EventStatusBadgeColor, EventStatusKr } from '@models/event/extension';
import { Link } from '@router/Link';
import dayjs from 'dayjs';

import styles from './styles.module.scss';

interface Props {
    event: EventRow;
}

function EventItem({ event }:Props) {
  const {
    id, status, startAt, endAt, listBannerImageUrl, title, contentSummary, isPinned,
  } = event;
  return (
        <Link activityParams={{ eventId: id }}
              activityName='EventActivity'
              className={styles.container}>
            {isPinned && (
                <div className={styles.pin}>
                    <PinFixedFill size={20}
                                  color={colors.white}/>
                </div>
            )}
            <Column spacing={12} fullWidth className={styles.body}>
                <Badge variant='outline'
                       color={EventStatusBadgeColor[status]}>
                    {EventStatusKr[status]}
                </Badge>
                <Text size='xl' fontWeight='bold' className={styles.title}>{title}</Text>
                <Image src={listBannerImageUrl}
                       className={styles.image}
                       alt='이벤트'/>
                <Text color={colors.gray7}
                      as='div'
                      className={styles.content}
                      dangerouslySetInnerHTML={{ __html: contentSummary }}/>
            </Column>
            <div className={styles.footer}>
                <Text color={colors.gray6} >
                    {dayjs(startAt).format('MM.DD')}-{dayjs(endAt).format('MM.DD')}
                </Text>
            </div>
        </Link>
  );
}

export default EventItem;
